<div class="container">
  @if (shouldBeIndented()) {
    <div class="indentation"></div>
  }

  <div [formGroup]="formGroup()" class="criteria-group">
    @if (!isReadOnly()) {
      <div class="group-header">
        <div class="match-type">
          {{ translations.matchLabel }}
          <mat-tab-group
            animationDuration="0ms"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            class="no-content-margin"
            [selectedIndex]="selectedMatchTypeIndex()"
            (selectedIndexChange)="onMatchTypeChange($event)"
          >
            <mat-tab [label]="translations.all"></mat-tab>
            <mat-tab
              [disabled]="conditionTypeFormControls.length === 1"
              [label]="translations.any"
            ></mat-tab>
          </mat-tab-group>
        </div>
        <div>
          <app-button
            type="icon"
            class="large"
            [tp]="translations.deleteGroup"
            (pressed)="onRemove()"
          >
            <mat-icon>delete</mat-icon>
          </app-button>
        </div>
      </div>
    }

    <div class="flex-column" formArrayName="itemForms">
      @for (control of conditionTypeFormControls; track control; let last = $last) {
        <ng-container [formGroupName]="$index">
          <app-ruleset-criteria-item
            (remove)="onRemoveCriteria($index)"
            (convertToGroup)="convertCriteriaItemToGroup.emit($index)"
            [formGroup]="control"
            [isReadOnly]="isReadOnly()"
            [locationTypeOptions]="locationTypeOptions()"
            [countryOptions]="countryOptions()"
            [locationOptions]="locationOptions()"
            [shouldDisplayOptions]="!isReadOnly() && conditionTypeFormControls.length > 1"
            [booleanOperator]="!last ? matchType[selectedMatchTypeIndex()] : null"
            [shouldBeIndented]="conditionTypeFormControls.length > 1"
            [propertyOptions]="propertyOptions()"
          ></app-ruleset-criteria-item>
        </ng-container>
      }
    </div>

    @if (!isReadOnly()) {
      <app-button-group>
        <app-button type="ghost" (pressed)="onAddCriteria()">
          <mat-icon>add</mat-icon>
          {{ translations.addCriteria }}
        </app-button>
      </app-button-group>
    }
  </div>
</div>

@if (booleanOperator()) {
  <div class="boolean-operator">
    {{ booleanOperatorText() | uppercase }}
  </div>
}
